import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionWaterPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.v1.questionWater.heading')}
      subheading={t('pages.onboarding.v1.questionWater.subheading')}
      buttons={[
        {
          text: t('pages.onboarding.v1.questionWater.button1'),
          value: '8_plus_glasses',
        },
        {
          text: t('pages.onboarding.v1.questionWater.button2'),
          value: '4-7_glasses',
        },
        {
          text: t('pages.onboarding.v1.questionWater.button3'),
          value: '2-3_glasses',
        },
        {
          text: t('pages.onboarding.v1.questionWater.button4'),
          value: 'less_than_2',
        },
        {
          text: t('pages.onboarding.v1.questionWater.button5'),
          value: 'dont_track',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
